//IE11 Polyfills 
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';
import 'core-js/es6/promise';
import 'core-js/es6/object';

// import 'babel-polyfill';
import 'core-js/modules/es7.promise.finally';

//React
import React from 'react';
import ReactDOM from 'react-dom';

//App
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

//Add redux store
// import { createStore } from 'redux';
// import { Provider } from 'react-redux'

// //Import reducer and create a store
// import reducer from './Store/Reducer';
// const store = createStore(reducer);

// store.subscribe(() => {
//     console.log('[Subscription]', store.getState());
// });

// ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
